import { useState, useRef, useEffect } from 'react'
import { Download, ChevronDown } from 'lucide-react'

interface ExportDropdownProps {
  onExportPage: () => void
  onExportAll: () => void
  loading?: boolean
  pageCount?: number
  totalCount?: number
}

export function ExportDropdown({
  onExportPage,
  onExportAll,
  loading,
  pageCount,
  totalCount,
}: ExportDropdownProps) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    if (open) document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [open])

  return (
    <div ref={ref} className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        disabled={loading}
        className="inline-flex items-center gap-2 rounded border border-b4l-border bg-white px-3 py-2 text-sm font-medium text-b4l-text transition hover:bg-b4l-bg disabled:cursor-not-allowed disabled:text-b4l-text-muted"
      >
        {loading ? (
          <span className="h-3 w-3 animate-spin rounded-full border-2 border-b4l-text-muted/40 border-t-b4l-text" />
        ) : (
          <Download className="h-4 w-4" />
        )}
        Export XLSX
        <ChevronDown className="h-3 w-3" />
      </button>
      {open && (
        <div className="absolute right-0 top-full z-20 mt-1 w-64 rounded-md border border-b4l-border bg-white shadow-lg">
          <button
            type="button"
            onClick={() => {
              setOpen(false)
              onExportPage()
            }}
            className="block w-full px-3 py-2.5 text-left text-sm hover:bg-b4l-bg"
          >
            <div className="font-medium">Pagina curentă</div>
            {pageCount !== undefined && (
              <div className="text-[11px] text-b4l-text-muted">
                {pageCount.toLocaleString('ro-RO')} rezultate vizibile
              </div>
            )}
          </button>
          <div className="border-t border-b4l-border" />
          <button
            type="button"
            onClick={() => {
              setOpen(false)
              onExportAll()
            }}
            className="block w-full px-3 py-2.5 text-left text-sm hover:bg-b4l-bg"
          >
            <div className="font-medium">Toate (filtre aplicate)</div>
            {totalCount !== undefined && (
              <div className="text-[11px] text-b4l-text-muted">
                {totalCount.toLocaleString('ro-RO')} rezultate total
              </div>
            )}
          </button>
        </div>
      )}
    </div>
  )
}
